import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { LoadingOverlayComponent } from '@/shared/components/loading-overlay/loading-overlay.component';
import { DialogService } from '@/shared/services/dialog.service';

import { AuthService } from './core/auth/auth.service';
import { MainStore } from './core/store/main-store';
import { MasterDataStore } from './core/store/master-store';
import { ThemeService } from './core/theme/theme.service';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, LoadingOverlayComponent],
  template: `
    <div class="app-container">
      <router-outlet></router-outlet>
    </div>

    @if (dialogService.isLoadingWideAngleVideo()) {
      <app-loading-overlay [fixed]="true" label="Loading wide angle feed" />
    }
  `,
  styles: [
    `
      .app-container {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
      }
    `,
  ],
  providers: [MainStore],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  title = 'Tactik';
  readonly dialogService = inject(DialogService);

  // Inject services
  private readonly themeService = inject(ThemeService);
  private readonly mainStore = inject(MainStore);
  private readonly authService = inject(AuthService);
  private readonly masterDataStore = inject(MasterDataStore);

  constructor() {
    // Theme service is automatically initialized through injection
    console.log('Theme service initialized with theme:', this.themeService.currentTheme());
  }

  async ngOnInit(): Promise<void> {
    const isAuthenticated = await this.authService.checkAuthenticationStatus();

    if (isAuthenticated) {
      // Waiting for cognito session to be ready, need an asynchronuos
      setTimeout(() => {
        this.masterDataStore.loadAllMasters();
        this.mainStore.loadMultipleKpis();
      }, 1000);
    }
  }
}
